/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineContentCopy } from "react-icons/md";
import { BiLoaderAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import {
  selectRetrofitConfiguration,
  selectPartnerPreferences,
  setShowEmailPopup,
  showSnackbar
} from "../../../../Retrofit/store/slices/retrofit";
import EmailPopup from "../../EmailPopup/EmailPopup";
import { addToMyProducts, addToMyProject, addToMyList, addToMyCart, logEvent } from "../../../utils/api/api";
import t from "../../../utils/translation/translator";
import SharedSurvey from "../../../../Retrofit/components/Survey/SharedSurvey";
import { selectEventsData, selectUpdatingConfiguration } from "../../../store/slices/common";
import { getCurrentConfiguration } from "../../../utils/api/common";
import { buildAddToCartDataLayerEvent, logDataLayerEvent } from "../../../utils/dataLayerAnalytics/dataLayerAnalytics";
import { STEPS } from "../../../store/data/commonData";
import { gatherMc12ProductsForBOM } from "../../../../Mc12/utils/func.utils";
import { gatherCartesianProductsForBOM } from "../../../../Cartesian/utils/func.utils";
import { gatherRetrofitProductsForBOM } from "../../../../Retrofit/utils/func.util";
import { isWorkspaceAvailable, isUnifiedCheckoutAvailable } from "../../../utils/func.util";
import { selectIntegratedDrivesAxes } from "../../../../IntegratedDrives/store/slices/integrated_drives";
import { gatherIntegratedDrivesProductsForBOM } from "../../../../IntegratedDrives/utils/func.utils";

const ConfigurationSaved = ({ newDesign, ...props }) => {
  const configuration = getCurrentConfiguration();
  const eventsData = useSelector(selectEventsData);

  const updatingConfiguration = useSelector(selectUpdatingConfiguration);
  const dispatch = useDispatch();

  const partnerPreferences = useSelector(selectPartnerPreferences);
  const integratedDrivesAxes = useSelector(selectIntegratedDrivesAxes);

  const {
    refetch: execAddToMyProducts,
    isFetching: isFetchingAddToMyProducts,
    isLoading: isLoadingAddToMyProducts
  } = useQuery(
    "Add to my products",
    async () => {
      try {
        logEvent(
          eventsData.locale,
          eventsData.types.addToFavourites,
          eventsData.tags.finalizeStep,
          configuration?.configId
        );
        const eventName = "ADD_TO_MY_PRODUCTS";
        const steps = STEPS?.[configuration.configData.configurationType];

        const stepsArray = Object.values(steps).flat();
        const currentStepIndex = stepsArray.findIndex((step) => step.id === configuration.configData.currentStepId);
        const currentStepName = currentStepIndex > -1 ? stepsArray[currentStepIndex].label : "";
        var products = [];
        switch (configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configuration.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = gatherIntegratedDrivesProductsForBOM(integratedDrivesAxes);
            break;
          default:
            const { axes } = configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configuration.configId,
              name: configuration.configData?.configName,
              step: currentStepName
            },
            eventName,
            products
          )
        );
        // TODO : if is iframe => add to distributor card else add to my product
        // window.parent.postMessage({ type: 'ScWidgetSaveConfigurationEvent',
        // options: { configurationMasterId: configuration.id,
        // locale: payload.locale, country: payload.country,
        // products: payload.products, grouping: payload.grouping } }, '*');
        const res = await addToMyProducts(configuration);
        if (partnerPreferences === null) {
          dispatch(showSnackbar({ id: "BILL_ADDED" }));
        } else {
          dispatch(showSnackbar({ id: "BILL_ADDED", hideCTA: true }));
        }
        // console.log("Add to My products res =>", res);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configuration?.configId);
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToProject,
    isFetching: isFetchingAddToProject,
    isLoading: isLoadingAddToProject
  } = useQuery(
    "Add to my project",
    async () => {
      try {
        logEvent(
          eventsData.locale,
          eventsData.types.addToMyProject,
          eventsData.tags.finalizeStep,
          configuration?.configId
        );
        const eventName = "ADD_TO_MY_PROJECT";

        const steps = STEPS?.[configuration.configData.configurationType];

        const stepsArray = Object.values(steps).flat();
        const currentStepIndex = stepsArray.findIndex((step) => step.id === configuration.configData.currentStepId);
        const currentStepName = currentStepIndex > -1 ? stepsArray[currentStepIndex].label : "";

        var products = [];
        switch (configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configuration.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configuration.configId,
              name: configuration.configData?.configName,
              step: currentStepName
            },
            eventName,
            products
          )
        );
        // TODO : if is iframe => add to distributor card else add to my product
        // window.parent.postMessage({ type: 'ScWidgetSaveConfigurationEvent',
        // options: { configurationMasterId: configuration.id,
        // locale: payload.locale, country: payload.country,
        // products: payload.products, grouping: payload.grouping } }, '*');
        const res = await addToMyProject(configuration);
        // if (partnerPreferences === null) {
        //   dispatch(showSnackbar({ id: "BILL_ADDED" }));
        // } else {
        //   dispatch(showSnackbar({ id: "BILL_ADDED", hideCTA: true }));
        // }
        // console.log("Add to My products res =>", res);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configuration?.configId);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToMyList,
    isFetching: isFetchingAddToMyList,
    isLoading: isLoadingAddToMyList
  } = useQuery(
    "Add to my list",
    async () => {
      try {
        logEvent(
          eventsData.locale,
          eventsData.types.addToMyList,
          eventsData.tags.finalizeStep,
          configuration?.configId
        );
        const eventName = "ADD_TO_MY_LIST";

        const steps = STEPS?.[configuration.configData.configurationType];

        const stepsArray = Object.values(steps).flat();
        const currentStepIndex = stepsArray.findIndex((step) => step.id === configuration.configData.currentStepId);
        const currentStepName = currentStepIndex > -1 ? stepsArray[currentStepIndex].label : "";

        var products = [];
        switch (configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configuration.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configuration.configId,
              name: configuration.configData?.configName,
              step: currentStepName
            },
            eventName,
            products
          )
        );
        // TODO : if is iframe => add to distributor card else add to my list
        // window.parent.postMessage({ type: 'ScWidgetSaveConfigurationEvent',
        // options: { configurationMasterId: configuration.id,
        // locale: payload.locale, country: payload.country,
        // products: payload.products, grouping: payload.grouping } }, '*');
        const res = await addToMyList(configuration);
        // if (partnerPreferences === null) {
        //   dispatch(showSnackbar({ id: "BILL_ADDED" }));
        // } else {
        //   dispatch(showSnackbar({ id: "BILL_ADDED", hideCTA: true }));
        // }
        // console.log("Add to My list res =>", res);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configuration?.configId);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToCart,
    isFetching: isFetchingAddToCart,
    isLoading: isLoadingAddToCart
  } = useQuery(
    "Add to my cart",
    async () => {
      try {
        logEvent(
          eventsData.locale,
          eventsData.types.addToMyCart,
          eventsData.tags.finalizeStep,
          configuration?.configId
        );
        const eventName = "ADD_TO_MY_CART";

        const steps = STEPS?.[configuration.configData.configurationType];

        const stepsArray = Object.values(steps).flat();
        const currentStepIndex = stepsArray.findIndex((step) => step.id === configuration.configData.currentStepId);
        const currentStepName = currentStepIndex > -1 ? stepsArray[currentStepIndex].label : "";

        var products = [];
        switch (configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configuration.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configuration.configId,
              name: configuration.configData?.configName,
              step: currentStepName
            },
            eventName,
            products
          )
        );
        // TODO : if is iframe => add to distributor card else add to my cart
        // window.parent.postMessage({ type: 'ScWidgetSaveConfigurationEvent',
        // options: { configurationMasterId: configuration.id,
        // locale: payload.locale, country: payload.country,
        // products: payload.products, grouping: payload.grouping } }, '*');
        const res = await addToMyCart(configuration);
        // if (partnerPreferences === null) {
        //   dispatch(showSnackbar({ id: "BILL_ADDED" }));
        // } else {
        //   dispatch(showSnackbar({ id: "BILL_ADDED", hideCTA: true }));
        // }
        // console.log("Add to My Cart res =>", res);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, configuration?.configId);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleAddToMyProducts = () => {
    console.log("handleAddToMyProducts");
    execAddToMyProducts();
  };

  const handleAddToMyProject = () => {
    console.log("handleAddToMyProject");
    execAddToProject();
  };

  const handleAddToMyCart = () => {
    console.log("handleAddToMyCart");
    execAddToCart();
  };

  const handleAddToMyList = () => {
    console.log("handleAddToMyList");
    execAddToMyList();
  };

  return (
    <>
      <div
        className={`ConfigurationSaved mt-4 md:m-0 p-3.5
        ${newDesign ? "" : "bg-gray-10 mobile-box-shadow md:shadow-none md:p-8"}`}
        {...props}
      >
        <SharedSurvey disclaimer />
        <div className="flex items-center flex-col md:flex-row">
          {configuration.configId && !updatingConfiguration && (
            <>
              <IoIosCheckmarkCircleOutline className="text-primary text-5xl md:text-3xl md:mr-2" />
              <span className="text-lg font-semibold text-gray-500 tracking-tight">
                {t("msizer.ui.configuration_saved_card.title")}
              </span>
            </>
          )}
          {updatingConfiguration && (
            <>
              <BiLoaderAlt className="text-primary text-5xl md:text-3xl md:mr-2 animate-spin" />
              <span className="text-lg font-semibold text-gray-500 tracking-tight">
                {t("msizer.ui.configuration_saved_card.loading.title")}
              </span>
            </>
          )}
        </div>
        <div className="flex flex-col space-y-2 mt-3">
          <div className="qds-controls qds-related flex-row w-full flex flex-wrap gap-2 mt-2">
            {isUnifiedCheckoutAvailable() && (
              <qds-button
                id="finalize-button-add-list"
                onClick={() => {
                  handleAddToMyList();
                }}
                text={t("msizer.ui.add_to_my_list")}
                {...(isFetchingAddToMyList || isLoadingAddToMyList ? { disabled: "" } : {})}
                class="flex-1"
              ></qds-button>
            )}
            <qds-button
              importance="emphasized"
              id="finalize-button-add-products"
              onClick={() => {
                if (isUnifiedCheckoutAvailable()) {
                  handleAddToMyCart();
                } else if (isWorkspaceAvailable()) {
                  handleAddToMyProject();
                } else {
                  handleAddToMyProducts();
                }
              }}
              text={
                partnerPreferences?.addToCartAlias ||
                t(
                  isUnifiedCheckoutAvailable()
                    ? "msizer.ui.add_to_my_cart"
                    : isWorkspaceAvailable()
                      ? "msizer.ui.add_to_my_project"
                      : "msizer.ui.add_to_my_products"
                )
              }
              {...(isFetchingAddToCart ||
              isLoadingAddToCart ||
              isFetchingAddToMyProducts ||
              isLoadingAddToMyProducts ||
              isFetchingAddToProject ||
              isLoadingAddToProject
                ? { disabled: "" }
                : {})}
              class="flex-1"
            ></qds-button>
          </div>
        </div>
      </div>
      <EmailPopup configId={configuration.configId} />
    </>
  );
};

export default ConfigurationSaved;
